import React from 'react'
import {
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

export default function ChatActionsDropdown({ chat, message, handleForwardCLick, chatMessages, index, deleteMessage, currentUser, editHandler, onReply }) {
  const { t } = useTranslation();

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text)
      .then(() => {
        toast.success("Copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  return (
    <UncontrolledDropdown className="align-self-start">
      <DropdownToggle tag="a"><i className="ri-more-2-fill"></i></DropdownToggle>
      <DropdownMenu className="dropdown-menu-sm">
        <DropdownItem onClick={() => onReply()}>
          {t("Reply")}{" "}
          <i className="ri-reply-line float-end text-muted"></i>
        </DropdownItem>

        <DropdownItem>
          {t("Quote")}{" "}
          <i className="ri-double-quotes-l float-end text-muted"></i>
        </DropdownItem>

        {chat?.sender === currentUser?._id &&
          <DropdownItem onClick={() => editHandler({ isEditing: true, messageId: chat._id, messageText: message, currentChat: chat })}>
            Edit <i className="ri-edit-line float-end text-muted"></i>
          </DropdownItem>
        }

        <DropdownItem onClick={() => handleCopy(message)}>
          Copy <i className="ri-file-copy-line float-end text-muted"></i>
        </DropdownItem>
        <DropdownItem>
          Save <i className="ri-save-line float-end text-muted"></i>
        </DropdownItem>
        <DropdownItem onClick={() => handleForwardCLick(chat)}>
          Forward <i className="ri-chat-forward-line float-end text-muted"></i>
        </DropdownItem>
        {chat?.sender === currentUser?._id &&
          <DropdownItem onClick={() => deleteMessage(chat)}>
            Delete <i className="ri-delete-bin-line float-end text-muted"></i>
          </DropdownItem>}
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}
